/**
 * RV COA Modal Controller
 * Manages opening/closing COA modal and loading PDF documents
 */

window.rvCoaModal = (() => {
  const modal = document.getElementById('rv-coa-modal');
  const backdrop = modal?.querySelector('.rv-coa-modal__backdrop');
  const documentContainer = modal?.querySelector('#rv-coa-document');

  const open = (coaPdfUrl, productTitle = '') => {
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Load PDF
    if (coaPdfUrl) {
      if (coaPdfUrl.endsWith('.pdf')) {
        documentContainer.innerHTML = `
          <iframe
            src="${coaPdfUrl}"
            title="Certificate of Analysis for ${productTitle}"
            allowfullscreen
          ></iframe>
        `;
      } else {
        documentContainer.innerHTML = `
          <a href="${coaPdfUrl}" target="_blank" rel="noopener" class="rv-button rv-button--primary">
            Open Certificate of Analysis
          </a>
        `;
      }
    } else {
      documentContainer.innerHTML = `
        <p>Certificate of Analysis not available. Please contact support for more information.</p>
      `;
    }
  };

  const close = () => {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // Close on backdrop click
  if (backdrop) {
    backdrop.addEventListener('click', close);
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
      close();
    }
  });

  return { open, close };
})();
